import List from './list/InsuranceNetworkAggregatedListInitialState'

const { Record } = require('immutable')

export default Record({
    list: List()
})